import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
// import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";

import Routes from "src/Routes";
// import { Menu } from "src/framework/components/navigations";
import { ApplicationBar } from "src/framework/components/navigations";

import { isLoggedIn$, openMenu$ } from "src/framework/store";
import { useObservable } from "src/framework/store/storeUtil";
import "./styles.scss"

const drawerWidth = 0;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100%"
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerContainer: {
      overflow: "auto",
      marginBottom: "40px",
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: "none",
    },
    acticeLink: {
      color: "inherit",
      textDecoration: "inherit",
    },
    menuItemHeader: theme.mixins.toolbar,
    menuFooter: {
      width: "288px",
      minHeight: "40px",
      backgroundColor: "white",
      display: "block",
      position: "absolute",
      bottom: "0",
    },
    // menuFooterContent: {
    //   flex: 1,
    // },

    content: {
      flexGrow: 1,
      height: "100%",
      // padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    navLink: {
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
    }
  })
);

interface MainProperties {
  onExit: () => void;
  onInit: () => void;
}

const Main: FC<MainProperties> =
  ({ onExit = () => { }, onInit = () => { } }) => {
    const classes = useStyles();

    const isLoggedIn = useObservable(isLoggedIn$)
    const openMenu = useObservable(openMenu$);

    useEffect(() => {
      onInit();
    }, [isLoggedIn]);

    useEffect(() => {
      return () => {
        onExit();
      };
    }, []);

    return (

      <div className={classes.root}>
        <CssBaseline />
        <ApplicationBar classes={classes} />
        {/* <Drawer
          variant="persistent"
          anchor="left"
          open={openMenu}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <Menu classes={classes} />
        </Drawer> */}
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: !openMenu,
          }, "main")} 
        >
          <Toolbar />
          <Routes />
        </main>
      </div>
    );
  };
export { Main };
